import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { StructuralAnalysis } from '@modules/Analysis/partials/StructuralAnalysis';


type StructuralAnalysisDialogProps = {
  open: boolean;
  onClose: () => void;
  options: {
    storyId: string;
  }
};

export const StructuralAnalysisDialog: React.FC<StructuralAnalysisDialogProps> = ({
  open,
  onClose,
  options = {},
}) => {
  const theme = useTheme();
  const { storyId } = options;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={isMobile}
    >
      <DialogTitle>
        {storyId && (<StructuralAnalysis storyId={storyId} loadingText="Loading..." isMobile={isMobile}/>)}
      </DialogTitle>

      <DialogContent>
      </DialogContent>
    </Dialog>
  );
};